import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAttachedCategory, LazyAttachedToOrganisation, LazyAttachedToUser, LazyCreatedAssociationSettings, LazyCreatedDocumentFormProcess, LazyCreatedEvent, LazyCreatedEventPerson, LazyCreatedEventPersonFormProcess, LazyCreatedExecutedProgram, LazyCreatedFormProcess, LazyCreatedMail, LazyCreatedProcess, LazyCreatedUserFilter, LazyDeletedDocumentFormProcess, LazyDeletedEvent, LazyDeletedEventPerson, LazyDeletedEventPersonFormProcess, LazyDeletedExecutedProgram, LazyDeletedFormProcess, LazyDeletedProcess, LazyDeletedUserFilter, LazyDetachedCategory, LazyDetachedFromOrganisation, LazyDetachedFromUser, LazyUpdatedAssociationSettings, LazyRemovedSignature, LazyUpdatedEvent, LazyUpdatedExecutedProgram, LazyUpdatedFormProcess, LazyUpdatedFormProcessStatus, LazyUpdatedMail, LazyUpdatedMailStatus, LazyUpdatedProcess, LazyUpdatedProcessStatus, LazyUpdatedSignature, LazyTableFilterBoolean, LazyTableFilterNewFilterTemplate, LazyTableFilterNumeric, LazyTableFilterProcessStatus, LazyTableFilterSearchSelect, LazyTableFilterSelect, LazyTableFilterShortcut, LazyTableFilterString, LazyTableToolCategoriesCreate, LazyTableToolChildOrganisationsCreate, LazyTableToolFormsCreate, LazyTableToolFundingProgramsCreate, LazyTableToolGeneralExport, LazyTableToolMailTemplatesCreate, LazyTableToolOrganisationUsersCreate, LazyTableToolOrganisationsAttachCategory, LazyTableToolOrganisationsCreate, LazyTableToolOrganisationsToggle, LazyTableToolProcessesChangeStatus, LazyTableToolProcessesCreate, LazyTableToolProcessesCreatorUserMail, LazyTableToolProcessesExcelExport, LazyTableToolProcessesMassApproval, LazyTableToolProcessesPaymentRuns, LazyTableToolProcessesReporting, LazyTableToolRolesCreate, LazyTableToolStatusNotificationsCreate, LazyTableToolStatusesCreate, LazyTableToolUserOrganisationsCreate, LazyTableToolUsersCreate, LazyTableToolUsersDelete, LazyTableToolYearInterviewsCreate, LazyTableToolYearsCreate, LazyDashboardWidgetGeneralTableIndex, LazyDashboardWidgetGeneralTableStatus, LazyFailedMail, LazySyncedDocuments, LazyKJPIBAV1A, LazyKJPIBAV1V, LazyKJPIBAV31A, LazyKJPIBAV31AU, LazyKJPIBAV31EB, LazyKJPIBAV31V, LazyKJPIBAV31WLV, LazyKJPIBAV31ZV, LazyKJPIBAV32A, LazyKJPIBAV32AU, LazyKJPIBAV32EB, LazyKJPIBAV32V, LazyKJPIBAV32WLV, LazyKJPIBAV32ZV, LazyKJPIBAV4FKA, LazyKJPIBAV4FKAU, LazyKJPIBAV4FKEB, LazyKJPIBAV4FKV, LazyKJPIBAV4FKWLV, LazyKJPIBAV4FKZV, LazyKJPIBAV4JGA, LazyKJPIBAV4JGAU, LazyKJPIBAV4JGEB, LazyKJPIBAV4JGV, LazyKJPIBAV4JGWLV, LazyKJPIBAV4JGZV, LazyKJPIBAV6A, LazyKJPIBAV6V, LazyKJPIBFKINA, LazyKJPIBFKINAU, LazyKJPIBFKINEB, LazyKJPIBFKINV, LazyKJPIBFKINWLV, LazyKJPIBFKINZV, LazyKJPIBFKOUTA, LazyKJPIBFKOUTAU, LazyKJPIBFKOUTEB, LazyKJPIBFKOUTV, LazyKJPIBFKOUTWLV, LazyKJPIBFKOUTZV, LazyKJPIBJGINA, LazyKJPIBJGINAU, LazyKJPIBJGINEB, LazyKJPIBJGINV, LazyKJPIBJGINWLV, LazyKJPIBJGINZV, LazyKJPIBJGOUTA, LazyKJPIBJGOUTAU, LazyKJPIBJGOUTEB, LazyKJPIBJGOUTV, LazyKJPIBJGOUTWLV, LazyKJPIBJGOUTZV, LazyKJPIBPV, LazyKJPIWCAV6A, LazyKJPIWCAV6AU, LazyKJPIWCAV6EB, LazyKJPIWCAV6V, LazyKJPIWCAV6WLV, LazyKJPIWCAV6ZV, LazyKJPIWCJGINA, LazyKJPIWCJGINAU, LazyKJPIWCJGINEB, LazyKJPIWCJGINV, LazyKJPIWCJGINWLV, LazyKJPIWCJGINZV, LazyKJPIWCJGOUTA, LazyKJPIWCJGOUTAU, LazyKJPIWCJGOUTEB, LazyKJPIWCJGOUTV, LazyKJPIWCJGOUTWLV, LazyKJPIWCJGOUTZV, LazyKJPIWCPV, LazyKJPNJAU, LazyKJPNJAV1A, LazyKJPNJAV1V, LazyKJPNJAV31A, LazyKJPNJAV31V, LazyKJPNJAV32A, LazyKJPNJAV32V, LazyKJPNJAV4A, LazyKJPNJAV4V, LazyKJPNJAV5AVK1A, LazyKJPNJAV5AVK1V, LazyKJPNJAV5AVK2A, LazyKJPNJAV5AVK2V, LazyKJPNJAV5AVK3A, LazyKJPNJAV5AVK3V, LazyKJPNJAV6A, LazyKJPNJAV6V, LazyKJPNJPV, LazyKJPNJWLV, LazyKJPNJZV, LazyKJPPBAV1A, LazyKJPPBAV1V, LazyKJPPBAV31A, LazyKJPPBAV31V, LazyKJPPBAV32A, LazyKJPPBAV32V, LazyKJPPBAV4A, LazyKJPPBAV4V, LazyKJPPBAV5AVK1A, LazyKJPPBAV5AVK1V, LazyKJPPBAV5AVK2A, LazyKJPPBAV5AVK2V, LazyKJPPBAV5AVK3A, LazyKJPPBAV5AVK3V, LazyKJPPBAV6A, LazyKJPPBAV6V, LazyKJPPBPV, LazyKJPPBWLV, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["AttachedCategory", LazyAttachedCategory],
["AttachedToOrganisation", LazyAttachedToOrganisation],
["AttachedToUser", LazyAttachedToUser],
["CreatedAssociationSettings", LazyCreatedAssociationSettings],
["CreatedDocumentFormProcess", LazyCreatedDocumentFormProcess],
["CreatedEvent", LazyCreatedEvent],
["CreatedEventPerson", LazyCreatedEventPerson],
["CreatedEventPersonFormProcess", LazyCreatedEventPersonFormProcess],
["CreatedExecutedProgram", LazyCreatedExecutedProgram],
["CreatedFormProcess", LazyCreatedFormProcess],
["CreatedMail", LazyCreatedMail],
["CreatedProcess", LazyCreatedProcess],
["CreatedUserFilter", LazyCreatedUserFilter],
["DeletedDocumentFormProcess", LazyDeletedDocumentFormProcess],
["DeletedEvent", LazyDeletedEvent],
["DeletedEventPerson", LazyDeletedEventPerson],
["DeletedEventPersonFormProcess", LazyDeletedEventPersonFormProcess],
["DeletedExecutedProgram", LazyDeletedExecutedProgram],
["DeletedFormProcess", LazyDeletedFormProcess],
["DeletedProcess", LazyDeletedProcess],
["DeletedUserFilter", LazyDeletedUserFilter],
["DetachedCategory", LazyDetachedCategory],
["DetachedFromOrganisation", LazyDetachedFromOrganisation],
["DetachedFromUser", LazyDetachedFromUser],
["UpdatedAssociationSettings", LazyUpdatedAssociationSettings],
["RemovedSignature", LazyRemovedSignature],
["UpdatedEvent", LazyUpdatedEvent],
["UpdatedExecutedProgram", LazyUpdatedExecutedProgram],
["UpdatedFormProcess", LazyUpdatedFormProcess],
["UpdatedFormProcessStatus", LazyUpdatedFormProcessStatus],
["UpdatedMail", LazyUpdatedMail],
["UpdatedMailStatus", LazyUpdatedMailStatus],
["UpdatedProcess", LazyUpdatedProcess],
["UpdatedProcessStatus", LazyUpdatedProcessStatus],
["UpdatedSignature", LazyUpdatedSignature],
["TableFilterBoolean", LazyTableFilterBoolean],
["TableFilterNewFilterTemplate", LazyTableFilterNewFilterTemplate],
["TableFilterNumeric", LazyTableFilterNumeric],
["TableFilterProcessStatus", LazyTableFilterProcessStatus],
["TableFilterSearchSelect", LazyTableFilterSearchSelect],
["TableFilterSelect", LazyTableFilterSelect],
["TableFilterShortcut", LazyTableFilterShortcut],
["TableFilterString", LazyTableFilterString],
["TableToolCategoriesCreate", LazyTableToolCategoriesCreate],
["TableToolChildOrganisationsCreate", LazyTableToolChildOrganisationsCreate],
["TableToolFormsCreate", LazyTableToolFormsCreate],
["TableToolFundingProgramsCreate", LazyTableToolFundingProgramsCreate],
["TableToolGeneralExport", LazyTableToolGeneralExport],
["TableToolMailTemplatesCreate", LazyTableToolMailTemplatesCreate],
["TableToolOrganisationUsersCreate", LazyTableToolOrganisationUsersCreate],
["TableToolOrganisationsAttachCategory", LazyTableToolOrganisationsAttachCategory],
["TableToolOrganisationsCreate", LazyTableToolOrganisationsCreate],
["TableToolOrganisationsToggle", LazyTableToolOrganisationsToggle],
["TableToolProcessesChangeStatus", LazyTableToolProcessesChangeStatus],
["TableToolProcessesCreate", LazyTableToolProcessesCreate],
["TableToolProcessesCreatorUserMail", LazyTableToolProcessesCreatorUserMail],
["TableToolProcessesExcelExport", LazyTableToolProcessesExcelExport],
["TableToolProcessesMassApproval", LazyTableToolProcessesMassApproval],
["TableToolProcessesPaymentRuns", LazyTableToolProcessesPaymentRuns],
["TableToolProcessesReporting", LazyTableToolProcessesReporting],
["TableToolRolesCreate", LazyTableToolRolesCreate],
["TableToolStatusNotificationsCreate", LazyTableToolStatusNotificationsCreate],
["TableToolStatusesCreate", LazyTableToolStatusesCreate],
["TableToolUserOrganisationsCreate", LazyTableToolUserOrganisationsCreate],
["TableToolUsersCreate", LazyTableToolUsersCreate],
["TableToolUsersDelete", LazyTableToolUsersDelete],
["TableToolYearInterviewsCreate", LazyTableToolYearInterviewsCreate],
["TableToolYearsCreate", LazyTableToolYearsCreate],
["DashboardWidgetGeneralTableIndex", LazyDashboardWidgetGeneralTableIndex],
["DashboardWidgetGeneralTableStatus", LazyDashboardWidgetGeneralTableStatus],
["FailedMail", LazyFailedMail],
["SyncedDocuments", LazySyncedDocuments],
["KJPIBAV1A", LazyKJPIBAV1A],
["KJPIBAV1V", LazyKJPIBAV1V],
["KJPIBAV31A", LazyKJPIBAV31A],
["KJPIBAV31AU", LazyKJPIBAV31AU],
["KJPIBAV31EB", LazyKJPIBAV31EB],
["KJPIBAV31V", LazyKJPIBAV31V],
["KJPIBAV31WLV", LazyKJPIBAV31WLV],
["KJPIBAV31ZV", LazyKJPIBAV31ZV],
["KJPIBAV32A", LazyKJPIBAV32A],
["KJPIBAV32AU", LazyKJPIBAV32AU],
["KJPIBAV32EB", LazyKJPIBAV32EB],
["KJPIBAV32V", LazyKJPIBAV32V],
["KJPIBAV32WLV", LazyKJPIBAV32WLV],
["KJPIBAV32ZV", LazyKJPIBAV32ZV],
["KJPIBAV4FKA", LazyKJPIBAV4FKA],
["KJPIBAV4FKAU", LazyKJPIBAV4FKAU],
["KJPIBAV4FKEB", LazyKJPIBAV4FKEB],
["KJPIBAV4FKV", LazyKJPIBAV4FKV],
["KJPIBAV4FKWLV", LazyKJPIBAV4FKWLV],
["KJPIBAV4FKZV", LazyKJPIBAV4FKZV],
["KJPIBAV4JGA", LazyKJPIBAV4JGA],
["KJPIBAV4JGAU", LazyKJPIBAV4JGAU],
["KJPIBAV4JGEB", LazyKJPIBAV4JGEB],
["KJPIBAV4JGV", LazyKJPIBAV4JGV],
["KJPIBAV4JGWLV", LazyKJPIBAV4JGWLV],
["KJPIBAV4JGZV", LazyKJPIBAV4JGZV],
["KJPIBAV6A", LazyKJPIBAV6A],
["KJPIBAV6V", LazyKJPIBAV6V],
["KJPIBFKINA", LazyKJPIBFKINA],
["KJPIBFKINAU", LazyKJPIBFKINAU],
["KJPIBFKINEB", LazyKJPIBFKINEB],
["KJPIBFKINV", LazyKJPIBFKINV],
["KJPIBFKINWLV", LazyKJPIBFKINWLV],
["KJPIBFKINZV", LazyKJPIBFKINZV],
["KJPIBFKOUTA", LazyKJPIBFKOUTA],
["KJPIBFKOUTAU", LazyKJPIBFKOUTAU],
["KJPIBFKOUTEB", LazyKJPIBFKOUTEB],
["KJPIBFKOUTV", LazyKJPIBFKOUTV],
["KJPIBFKOUTWLV", LazyKJPIBFKOUTWLV],
["KJPIBFKOUTZV", LazyKJPIBFKOUTZV],
["KJPIBJGINA", LazyKJPIBJGINA],
["KJPIBJGINAU", LazyKJPIBJGINAU],
["KJPIBJGINEB", LazyKJPIBJGINEB],
["KJPIBJGINV", LazyKJPIBJGINV],
["KJPIBJGINWLV", LazyKJPIBJGINWLV],
["KJPIBJGINZV", LazyKJPIBJGINZV],
["KJPIBJGOUTA", LazyKJPIBJGOUTA],
["KJPIBJGOUTAU", LazyKJPIBJGOUTAU],
["KJPIBJGOUTEB", LazyKJPIBJGOUTEB],
["KJPIBJGOUTV", LazyKJPIBJGOUTV],
["KJPIBJGOUTWLV", LazyKJPIBJGOUTWLV],
["KJPIBJGOUTZV", LazyKJPIBJGOUTZV],
["KJPIBPV", LazyKJPIBPV],
["KJPIWCAV6A", LazyKJPIWCAV6A],
["KJPIWCAV6AU", LazyKJPIWCAV6AU],
["KJPIWCAV6EB", LazyKJPIWCAV6EB],
["KJPIWCAV6V", LazyKJPIWCAV6V],
["KJPIWCAV6WLV", LazyKJPIWCAV6WLV],
["KJPIWCAV6ZV", LazyKJPIWCAV6ZV],
["KJPIWCJGINA", LazyKJPIWCJGINA],
["KJPIWCJGINAU", LazyKJPIWCJGINAU],
["KJPIWCJGINEB", LazyKJPIWCJGINEB],
["KJPIWCJGINV", LazyKJPIWCJGINV],
["KJPIWCJGINWLV", LazyKJPIWCJGINWLV],
["KJPIWCJGINZV", LazyKJPIWCJGINZV],
["KJPIWCJGOUTA", LazyKJPIWCJGOUTA],
["KJPIWCJGOUTAU", LazyKJPIWCJGOUTAU],
["KJPIWCJGOUTEB", LazyKJPIWCJGOUTEB],
["KJPIWCJGOUTV", LazyKJPIWCJGOUTV],
["KJPIWCJGOUTWLV", LazyKJPIWCJGOUTWLV],
["KJPIWCJGOUTZV", LazyKJPIWCJGOUTZV],
["KJPIWCPV", LazyKJPIWCPV],
["KJPNJAU", LazyKJPNJAU],
["KJPNJAV1A", LazyKJPNJAV1A],
["KJPNJAV1V", LazyKJPNJAV1V],
["KJPNJAV31A", LazyKJPNJAV31A],
["KJPNJAV31V", LazyKJPNJAV31V],
["KJPNJAV32A", LazyKJPNJAV32A],
["KJPNJAV32V", LazyKJPNJAV32V],
["KJPNJAV4A", LazyKJPNJAV4A],
["KJPNJAV4V", LazyKJPNJAV4V],
["KJPNJAV5AVK1A", LazyKJPNJAV5AVK1A],
["KJPNJAV5AVK1V", LazyKJPNJAV5AVK1V],
["KJPNJAV5AVK2A", LazyKJPNJAV5AVK2A],
["KJPNJAV5AVK2V", LazyKJPNJAV5AVK2V],
["KJPNJAV5AVK3A", LazyKJPNJAV5AVK3A],
["KJPNJAV5AVK3V", LazyKJPNJAV5AVK3V],
["KJPNJAV6A", LazyKJPNJAV6A],
["KJPNJAV6V", LazyKJPNJAV6V],
["KJPNJPV", LazyKJPNJPV],
["KJPNJWLV", LazyKJPNJWLV],
["KJPNJZV", LazyKJPNJZV],
["KJPPBAV1A", LazyKJPPBAV1A],
["KJPPBAV1V", LazyKJPPBAV1V],
["KJPPBAV31A", LazyKJPPBAV31A],
["KJPPBAV31V", LazyKJPPBAV31V],
["KJPPBAV32A", LazyKJPPBAV32A],
["KJPPBAV32V", LazyKJPPBAV32V],
["KJPPBAV4A", LazyKJPPBAV4A],
["KJPPBAV4V", LazyKJPPBAV4V],
["KJPPBAV5AVK1A", LazyKJPPBAV5AVK1A],
["KJPPBAV5AVK1V", LazyKJPPBAV5AVK1V],
["KJPPBAV5AVK2A", LazyKJPPBAV5AVK2A],
["KJPPBAV5AVK2V", LazyKJPPBAV5AVK2V],
["KJPPBAV5AVK3A", LazyKJPPBAV5AVK3A],
["KJPPBAV5AVK3V", LazyKJPPBAV5AVK3V],
["KJPPBAV6A", LazyKJPPBAV6A],
["KJPPBAV6V", LazyKJPPBAV6V],
["KJPPBPV", LazyKJPPBPV],
["KJPPBWLV", LazyKJPPBWLV],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
